function getWeekDates(
  startDate: Date,
  onlyWeekDays: boolean = false,
): [Date, Date] {
  const startOfWeek = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate() - startDate.getDay() + 1,
  );
  const endOfWeek = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate() - startDate.getDay() + (onlyWeekDays ? 5 : 7),
  );
  return [startOfWeek, endOfWeek];
}

export function getDates(date: Date) {
  const currentDate = date ?? new Date();
  const [startDate, endDate] = getWeekDates(currentDate);

  return { startDate, endDate };
}

export function getFormattedWeekDates(
  date: Date,
  monthFormat: 'long' | 'short' = 'long',
) {
  const { startDate, endDate } = getDates(date);
  const localeStart = startDate.toLocaleString('en-GB', {
    day: '2-digit',
  });
  const localeEnd = endDate.toLocaleString('en-GB', { day: '2-digit' });
  const isDifferentMonth = startDate.getMonth() !== endDate.getMonth();
  const isDifferentYear = startDate.getFullYear() !== endDate.getFullYear();

  if (isDifferentYear) {
    return `${localeStart} ${startDate.toLocaleString('en-GB', {
      month: monthFormat,
      year: 'numeric',
    })} - ${localeEnd} ${endDate.toLocaleString('en-GB', {
      month: monthFormat,
      year: 'numeric',
    })}`;
  }

  if (isDifferentMonth) {
    return `${localeStart} ${startDate.toLocaleString('en-GB', {
      month: monthFormat,
    })} - ${localeEnd} ${endDate.toLocaleString('en-GB', {
      month: monthFormat,
      year: 'numeric',
    })}`;
  }

  return `${localeStart} - ${localeEnd} ${date.toLocaleString('en-GB', {
    month: monthFormat,
    year: 'numeric',
  })}`;
}
